import type { LucideIcon } from 'lucide-react';

import { cn } from '@/lib/cn';

interface Props {
  label: string;
  value: string | number;
  icon?: LucideIcon;
  delta?: { value: string; direction: 'up' | 'down' | 'flat' };
}

export function KpiCard({ label, value, icon: Icon, delta }: Props): JSX.Element {
  return (
    <div className="mb-card p-4">
      <div className="flex items-center justify-between">
        <div className="text-xs uppercase tracking-wider text-mb-text-muted">{label}</div>
        {Icon ? <Icon className="h-4 w-4 text-mb-text-subtle" aria-hidden /> : null}
      </div>
      <div className="mt-2 font-display text-2xl font-semibold text-mb-text">{value}</div>
      {delta ? (
        <div
          className={cn(
            'mt-1 text-xs',
            delta.direction === 'up' && 'text-mb-success-press',
            delta.direction === 'down' && 'text-mb-danger',
            delta.direction === 'flat' && 'text-mb-text-muted',
          )}
        >
          {delta.value}
        </div>
      ) : null}
    </div>
  );
}
